import m from "react";
import d from "classnames";
import { u as l } from "./DarkModeProvider-xoZXm3ct.es.js";
import { u as c } from "./utils-C0l876fA.es.js";
import './ShimmerBlock.css';const n = "ShimmerBlock-module__dark___Mk-h4", e = {
  "hidden-span": "ShimmerBlock-module__hidden-span___4O3sg",
  "shimmer-block": "ShimmerBlock-module__shimmer-block___YwrBW",
  dark: n
}, u = ({
  className: s = "",
  role: o = "status",
  ...r
}) => {
  const a = l(), { t } = c();
  return /* @__PURE__ */ m.createElement(
    "div",
    {
      ...r,
      className: d(
        e["shimmer-block"],
        a && e.dark,
        s
      )
    },
    /* @__PURE__ */ m.createElement("span", { role: o, className: e["hidden-span"] }, t("loading"))
  );
};
export {
  u as S
};
